"use strict";

if (!Object.assign) {
	Object.assign = require("object-assign");
}

var keyMirror = require("keyMirror");

var Constants = keyMirror({
	UPDATE_SUBJECT: null,
	UPDATE_BODY: null,
	COPIED: null,
	SELECT_LAYOUT: null,
	ADD_LAYOUT: null,
	LAYOUT_DELETE: null,
	LAYOUT_DELETED: null,
	LAYOUT_DELETE_FAILED: null,
	LAYOUT_SAVE: null,
	LAYOUT_SAVED: null,
	LAYOUT_SAVE_FAILED: null,
	LAYOUT_SAVE_CANCELLED: null,
	LAYOUT_SAVED_AS: null, // Store Constant
	LAYOUT_SAVE_AS: null, // Action Constant
	LAYOUT_SAVE_AS_FAILED: null,
	LAYOUT_SAVE_AS_CANCELLED: null,
	LAYOUT_SAVE_DRAFT: null,
	LAYOUT_SET_SEO_DATA: null,
	DND_COMPONENT_MOVED: null,
	DND_COMPONENT_DROPPED: null,
	DND_COMPONENT_LOADED: null,
	DND_COMPONENT_UNLOADED: null,
	IFRAME_LOADED: null,
	IFRAME_CLICKED: null,
	IFRAME_DOUBLE_CLICKED: null,
	SET_PROPERTY: null,
	PROPERTIES_SAVED: null,
	PROPERTIES_SAVE_FAILED: null,
	DELETE_SELECTED_ELEMENT: null,
	CHANGE_EVENT: null,
	IFRAME_CLICKED_EVENT: null,
	IFRAME_CLICKED_EVENT_FOR_PROPERTY_EDITOR: null,
	SET_MODIFIER_SELECTED: null,
	SET_PSEUDOCLASS_SELECTED: null,
	CHILD_COMPONENT_LOADED: null,
	CHILD_COMPONENT_UNLOADED: null,
	STYLE_SHEET_RULE_REPLACED: null,
	STYLE_SHEET_RULE_DELETED: null,
	RECEIVE_PROPERTY_EDITOR_DATA: null,
	RECEIVE_PAGE_STORE_DATA: null,
	TAB_SELECTED: null,
	SET_TABS: null,
	LAYOUT_PUBLISH: null,
	LAYOUT_PUBLISH_SUCCESS: null,
	LAYOUT_PUBLISH_FAILED: null,
	STYLE_GUIDE_COMPONENT_GROUP_SELECTED: null,
	STYLE_GUIDE_COMPONENT_SELECTED: null,
	STYLE_GUIDE_RESET_REACT_COMPONENTS: null,
	RECEIVE_STYLEGUIDE_STORE_DATA: null,
	RECEIVE_COMPONENT_STORE_DATA: null,
	RESET_COMPONENT: null,
	RESET_COMPONENT_FAILED: null,
	THEME_SELECTED: null,
	THEMED_COMPONENT_SAVE_PENDING: null,
	THEMED_COMPONENT_SAVE_SUCCESS: null,
	THEMED_COMPONENT_SAVE_FAILED: null,
	THEME_SAVE_PENDING: null,
	THEME_SAVE_SUCCESS: null,
	THEME_SAVE_FAILED: null,
	THEME_SAVE_AS: null,
	THEME_SAVED_AS: null,
	THEME_SAVE_AS_FAILED: null,
	THEME_SAVE_AS_CANCELLED: null,
	THEME_DEACTIVATE: null,
	THEME_DEACTIVATED: null,
	THEME_DEACTIVATE_FAILED: null,
	THEME_REACTIVATE: null,
	THEME_REACTIVATED: null,
	THEME_REACTIVATE_FAILED: null,
	SAVE_REACT_PROPERTIES: null,
	ABANDON_UNSAVED_THEME_CHANGES: null,
	THEMED_COMPOMENTS_FETCHED: null,
	THEMED_COMPOMENTS_FETCH_FAILED: null,
	WIZARD_RECEIVE_STORE_DATA: null,
	THEMED_COMPOMENTS_FETCH_FAILED: null,
	SITE_THEME_CHANGE_PENDING: null,
	SITE_THEME_CHANGE_SUCCESS: null,
	SITE_THEME_CHANGE_FAILED: null,
	GENERIC_CHANGES: null, // used to trigger unsaved changes
	SELECT_PAGE: null,
	SELECT_PAGE_TYPE: null,
	DEVICE_SELECTED: null,
	APPLY_THEME_PENDING: null,
	APPLY_THEME_SUCCESS: null,
	APPLY_THEME_FAILED: null,
	REVERT_TO_DRAFT_PENDING: null,
	REVERT_TO_DRAFT_SUCCESS: null,
	REVERT_TO_DRAFT_FAILED: null,
	PUBLISH_THEME_PENDING: null,
	PUBLISH_THEME_SUCCESS: null,
	PUBLISH_THEME_FAILED: null,
	REVERT_TO_PUBLISHED_PENDING: null,
	REVERT_TO_PUBLISHED_SUCCESS: null,
	REVERT_TO_PUBLISHED_FAILED: null,
	TURN_EDITMODE_OFF: null,
	IFRAME_RESIZED: null,
	GET_QUERY_PARAM_OVERRIDES_PENDING: null,
	GET_QUERY_PARAM_OVERRIDES_SUCCESS: null,
	GET_QUERY_PARAM_OVERRIDES_FAILED: null,
	CATEGORY_INITIALIZE: null,
	CAROUSEL_INITIALIZE: null,
	CAROUSEL_NEXT_PAGE: null,
	CAROUSEL_PREVIOUS_PAGE: null,
	CAROUSEL_TOUCH_START: null,
	CAROUSEL_TOUCH_END: null,
	CART_UPDATE_CHARGE_TODAY: null,
	CART_UPDATE_FREQUENCY: null,
	CART_UPDATE_PRODUCT_OPCO_DISCOUNT: null, // used to update subtotal when OPCO coupon is applied.
	CART_UPDATE_PRODUCT_PRICE: null, // used to update price when suggested donation amount is changed.
	CART_UPDATE_QUANTITY: null,
	CART_UPDATE_USE_ON_DAY: null,
	CONTACT_US_INITIALIZE: null,
	DONATION_UPSELL_UPDATE: null,
	EMAIL_SUBSCRIPTION_INITIALIZE: null,
	EXPANDER_INITIALIZE: null,
	ADMIN_LOGIN_INITIALIZE: null,
	LOGOUT_INITIALIZE: null,
	TABS_INITIALIZE: null,
	NAVIGATION_INITIALIZE: null,
	ACCOUNT_INITIALIZE: null,
	CHECKOUT_BLUEFIN_TOKENIZATION_FAILED: null,
	CHECKOUT_BLUEFIN_TOKENIZATION_SUCCESS: null,
	CHECKOUT_INITIALIZE: null,
	PLEDGE_INITIALIZE: null,
	PLEDGE_SET_GIFT_AMOUNT: null,
	PLEDGE_SET_MINIMUM_AMOUNT: null,
	PRODUCT_INITIALIZE: null,
	PRODUCT_INITIALIZE_SUGGESTED_DONATION: null,
	PRODUCT_SET_QUANTITY: null,
	PRODUCT_SET_SUGGESTED_DONATION: null,
	SHIPPING_CANNOT_BE_CALCULATED: null,
	SHIPPING_IS_ALL_FREE: null,
	SHIPPING_REQUEST_PENDING: null,
	SHIPPING_UPDATED: null,
	SHIPPING_UPDATE_FAILED: null,
	SHIPPING_METHOD_UPDATED: null,
	SHIPTO_INITIALIZE: null,
	SHIPTO_SET_SELECTOR: null,
	TAX_UPDATED: null,
	TAX_UPDATE_FAILED: null,
	SLIDESHOW_INITIALIZE: null,
	SLIDESHOW_CHANGE_SLIDE: null,
	SLIDESHOW_STARTED: null,
	SLIDESHOW_STOPPED: null,
	SLIDESHOW_TOUCH_START: null,
	SLIDESHOW_TOUCH_END: null,
	PLEDGE_SET_FREQUENCY: null,
	TOGGLE_CREATE_ACCOUNT_FORM_INPUTS: null,
	SPONSORSHIP_AVAILABLITY: null,
	EVENT_SEARCH_INITIALIZE: null
});

// Layout Designer page URL consants
Constants.LANDING_PAGE_TYPES = {
	ACCOUNT: "Account",
	CONFIRMATION: "Confirmation",
	EVENT_SEARCH: "EventSearch",
	WIDGET: "Widget"
};

// Widget page types
Constants.WIDGET_TYPES = {
	DONATION: "Donation",
	EMAIL_SUBSCRIPTION: "Email Subscription"
};

//Account states
Constants.ACCOUNT_STATES = {
	UNIDENTIFIED: "accountState.unidentified",
	IDENTIFIED: "accountState.identified",
	LOGGEDIN: "accountState.loggedIn"
};

//Account types
Constants.ACCOUNT_TYPES = {
	INDIVIDUAL: "accountType.individual",
	ORGANIZATION: "accountType.organization"
};

Constants.DATE_FORMATS = {
	SE_API_DATE_FORMAT: "YYYY-MM-DD"
};

// Tangible Types
Constants.TANGIBLE_TYPES = {
	CHILD: "CHILD",
	PLEDGES: "PLEDGES",
	PRODUCTS: "PRODUCTS",
	PROJECTS: "PROJECTS",
	SECURE_PLEDGES: "SECURE_PLEDGES",
	SECURE_PROJECTS: "SECURE_PROJECTS"
};

// Cart item types
Constants.CART_ITEM_EVENT = "event";
Constants.CART_ITEM_PRODUCT = "product";
Constants.CART_ITEM_PROJECT = "project";
Constants.CART_ITEM_PROJECT_PREMIUM = "premium";
Constants.CART_ITEM_SUBSCRIPTION = "subscription";

// Cart Types
Constants.CART_TYPES = { SHOPPING_CART: "CURRENT", SAVE_FOR_LATER: "SFL" };

// Various
Constants.COLUMN_COMPONENTS = ["even01Column", "even02Column", "even03Column", "even04Column", "even06Column", "even12Column", "two01Column", "two02Column", "two03Column", "two04Column", "two05Column", "two06Column", "two07Column", "two08Column", "two09Column", "two10Column", "two11Column", "three02Column", "three04Column", "three06Column", "three08Column", "three10Column"];
Constants.COLUMN_SUBCOMPONENTS = ["even01Column.column", "even02Column.column", "even03Column.column", "even04Column.column", "even06Column.column", "even12Column.column", "two01Column.column", "two02Column.column", "two03Column.column", "two04Column.column", "two05Column.column", "two06Column.column", "two07Column.column", "two08Column.column", "two09Column.column", "two10Column.column", "two11Column.column", "three02Column.column", "three04Column.column", "three06Column.column", "three08Column.column", "three10Column.column"];
Constants.CONTAINER_COMPONENTS = Constants.COLUMN_COMPONENTS.concat(["expanderContainer", "tabsContainer", "accountState", "accountType", "slideShow", "hideWhen"]);
Constants.CONTAINER_SUBCOMPONENTS = Constants.COLUMN_SUBCOMPONENTS.concat(["expanderContainer.expander", "expanderContainer.expander.content", "tabsContainer.contentContainer", "tabsContainer.contentContainer.content", "tabsContainer.tabsList", "tabsContainer.tabsList.tab", "accountState.unidentified", "accountState.identified", "accountState.loggedIn", "accountType.individual", "accountType.organization", "slideShow.slideDeck.slide"]);

Constants.COUNTRIES = { US: "US", USA: "USA" };

Constants.PROPERTY_CATEGORY_SUFFIX = "DesignOnly";

Constants.KEYS = { ARROW_UP: 38, ARROW_RIGHT: 39, ARROW_DOWN: 40, ARROW_LEFT: 37, BACKSPACE: 8, DELETE: 46, END: 35, ENTER: 13, ESCAPE: 27, HOME: 36, PAGE_DOWN: 34, PAGE_UP: 33, TAB: 9, DECIMAL: 190, NUM_PAD_DECIMAL: 110, SPACE: 32, MINUS: 189, NUM_PAD_MINUS: 109 };

// Dynamic Property Constants
Constants.DYNAMIC_PROPERTY_GROUP_NAMES = ["dynamic", "dynamicPledge"];
Constants.DYNAMIC_PROPERTY_MAPS = {
	"dynamic": {
		propertyValue: "data-dynamic",
		propertyName: "data-dynamic-property"
	},

	"dynamicPledge": {
		propertyValue: "data-dynamic-pledge",
		propertyName: "data-dynamic-pledge-property"
	}
};

//SmartyStreets Constants
Constants.SMARTYSTREETS_DELIVERY_POINT_VALIDATION_STATUSES = { CONFIRMED: "Y", NOT_CONFIRMED: "N", CONFIRMED_BY_DROPPING_SECONDARY: "S", CONFIRMED_MISSED_SECONDARY_INFO: "D" };
Constants.SMARTYSTREETS_ADDRESS_VERIFICATION_STATUSES = { NONE: "NONE", VERIFIED: "Verified", PARTIAL: "Partial" };
Constants.SMARTYSTREETS_ADDRESS_PRECISIONS = { NONE: "NONE", STATE: "AdministrativeArea", CITY: "Locality", STREET: "Thoroughfare" };
Constants.SMARTYSTREETS_DELIVERY_POINT_VALIDATION_STATUSES = { CONFIRMED_MISSING_SECONDARY: "N1", CONFIRMED_WITHOUT_PRIVATE_MAILBOX_INFO: "R1" };
Constants.SMARTYSTREETS_FOOTNOTES = { MISSING_SECONDARY_INFORMATION: "H#" };
Constants.SMARTYSTREETS_ADDRESS_COMPONENTS = {
	PRIMARY_NUMBER: "primary_number", STREET_PREDIRECTION: "street_predirection", STREET_NAME: "street_name", STREET_POSTDIRECTION: "street_postdirection",
	STREET_SUFFIX: "street_suffix", SECONDARY_DESIGNATOR: "secondary_designator", SECONDARY_NUMBER: "secondary_number", EXTRA_SECONDARY_DESIGNATOR: "extra_secondary_designator",
	EXTRA_SECONDARY_NUMBER: "extra_secondary_number", CITY: "city_name", STATE_ABBREVIATION: "state_abbreviation", ZIPCODE: "zipcode", ZIPCODE_PLUS_FOUR: "plus4_code",
	DELIVERY_LINE_1: "delivery_line_1", DELIVERY_LINE_2: "delivery_line_2", URBANIZATION: "urbanization"
};
//General Address Verification Constants
Constants.ADDRESS_VERIFICATION_PROVIDERS = { SMARTYSTREETS: "SmartyStreets" };
Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES = { VERIFIED: "data-address-verified", USER_CERTIFIED: "data-user-verified", ERROR: "data-address-verification-error" };
Constants.ADDRESS_VERIFICATION_STATUSES = { VERIFIED: "Verified", USER_CERTIFIED: "UserCertified", ERROR: "Error" };

//Server Enums
Constants.APPROVAL_TYPES = { "NOTNEEDED": "NotNeeded", "PENDING": "Pending", "APPROVED": "Approved", "REJECTED": "Rejected", "FAILED": "Failed" };
Constants.DEVICE_TYPES = { "MOBILE": "mobile", "TABLET": "tablet", "DESKTOP": "desktop" };
Constants.LAYOUT_STATUSES = { "ACTIVE": "Active", "INACTIVE": "Inactive", "DELETED": "Deleted" };
Constants.LAYOUT_VERSIONS = { "DRAFT": "Draft", "PUBLISHED": "Published", "UNPUBLISHED": "Unpublished" };
Constants.THEME_VERSIONS = { "DRAFT": "Draft", "APPLIED": "Applied", "PUBLISHED": "Published", "UNPUBLISHED": "Unpublished" };

Constants.DEVICE_MIN_WIDTHS = { "MOBILE": 0, "TABLET": 768, "DESKTOP": 992 };

//Server Constants
Constants.QUERY_PARAMETER_OVERRIDES = { CUSTOM_PREFIX: "custom-" };

// Coupon Constants
Constants.COUPON_ERRORS = {
	GEO_RESTRICTION_INFO_NEEDED: "A valid account or country code and postal code combination must be provided to use this coupon."
};

//Category Editors
Constants.CATEGORY_EDITORS = { "POSITIONING": "Positioning" };

Constants.MICROSOFT_IDENTITY_PLATFORM = {
	ACCOUNT_ID_KEY: "msIdpAccountId",
	AUTHORITY_ROOT_URL: "https://login.microsoftonline.com",
	CACHE_LOCATION: "sessionStorage",
	COMMON_TENANT_ID: "common",
	ERROR_CODES: {
		INVALID_CLIENT: "invalid_client",
		INVALID_RESOURCE: "invalid_resource",
		UNAUTHORIZED_CLIENT: "unauthorized_client",
		USER_CANCELED: "user_cancelled"
	}
};

Constants.APPLE_PAY_PROPERTY_DEFAULTS = {
	BUTTON_STYLE: "black",
	WIDTH: "160px",
	HEIGHT: "48px",
	PADDING: "0px",
	BORDER_RADIUS: "100vh",
	BOX_SIZING: "content-box"
};

Constants.CHECKOUT_VALIDATION_TYPES = {
	CREATE_ACCOUNT_AND_CHECKOUT: "CACO",
	SAVED_PAYMENT_CHECKOUT: "SPCO",
	ALTERNATIVE_BUTTON_CHECKOUT: "ABCO"
};

Constants.SECURE_PAGE_TYPES = {
	PROJECT: "Project",
	PLEDGE: "Pledge"
};

Constants.BILLING_ADDRESS_SELECTION_TYPES = {
	DEFAULT: "DEFAULT",
	EXISTING: "EXISTING",
	NEW: "NEW",
	NEW_PRIMARY: "NEW_PRIMARY",
	NEW_SHIPPING: "NEW_SHIPPING",
};

module.exports = Constants;
